export const theme = {
  fontSize: '0.85rem',
  extraCarouselInsetWithoutBottomServiceMode: 0,
};
